import { parse } from "node-html-parser";
import { db } from "./firebase";
import { chargeFb } from "./firebase";

//1 : quantité
//2 : nom
export let store = [
  {
    link: "https://static.thenounproject.com/png/1936014-200.png",
    title: "Most popular college majors",
    nom: "Rank these majors",
    typeOfRank: "(by number of degrees awarded)",
    getTheData: async function (setter) {
      setter([
        ["289384", "Business and Management"],
        ["141632", "Nursing"],
        ["127066", "Psychology"],
        ["120375", "Biology"],
        ["117553", "Engineering"],
        ["102219", "Education"],
        ["98949", "Communications"],
        ["98663", "Finance and Accounting"],
        ["63961", "Criminal Justice"],
        ["57630", "Anthropology and Sociology"],
      ]);
    },
  },
  {
    link: "https://static.thenounproject.com/png/1649119-200.png",
    title: "Most popular programming languages",
    nom: "Rank programming languages",
    typeOfRank: "(by popularity on google trends)",
    getTheData: async function (setter) {
      setter([
        ["100", "Python"],
        ["90", "Java"],
        ["80", "Javascript"],
        ["70", "C#"],
        ["60", "PHP"],
        ["50", "C/C++"],
        ["40", "R"],
        ["30", "Objective-C"],
        ["20", "Swift"],
        ["10", "Typescript"],
      ]);
    },
  },
  {
    link:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Steam_icon_logo.svg/600px-Steam_icon_logo.svg.png",
    title: "Steam's most popular games",
    nom: "Rank the steam's games",
    typeOfRank: "(by active players)",
    getTheData: async function (setter) {
      let res1 = await db.collection("steam").get();

      if (!chargeFb(setter, res1, true)) {
        return;
      }

      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://store.steampowered.com/stats/Steam-Game-and-Player-Statistics",
        { mode: "no-cors" }
      );
     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll(".player_count_row");

        let childRes = [];
        let i = 0;
        for (let child of table) {
          let classs = [];
          for (let miniChild of child.querySelectorAll("span")) {
            classs.push(miniChild.innerHTML);
            break;
          }
          classs.push(child.querySelector("a").innerHTML);
          childRes.push(classs);
          i++;
          if (i > 9) {
            break;
          }
        }
        setter(childRes);

        for (let i = 1; i < 11; i++) {
          db.collection("steam")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("steam").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
      }
    },
  },
  {
    link:
      "data:image/png;base64,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",
    title: "Most popular countries",
    nom: "Most popular countries",
    typeOfRank: "(by tourists in 2019 (per million))",
    getTheData: async function (setter) {
      setter([
        ["4764644", "France"],
        ["4546819", "Spain"],
        ["4535897", "United States of America"],
        ["4323074", "China"],
        ["3631876", "Italy"],
        ["3560660", "Turkey"],
        ["2477879", "Mexico"],
        ["2367801", "Germany"],
        ["2167014", "Thailand"],
        ["2124748	", "United Kingdom"],
      ]);
    },
  },
  {
    link: "https://img.icons8.com/cotton/2x/mountain.png",
    title: "The highest mountains",
    nom: "The highest mountains",
    typeOfRank: "(km)",
    getTheData: async function (setter) {
      setter([
        ["8845", "Mount Everest - Himalaya - Népal/Chine"],
        ["8611", "K2 - Karakoram - Pakistan/Chine"],
        ["8586", "Kangchenjunga - Himalaya - Népal/Chine"],
        ["8516", "Lhotse - Himalaya - Népal/Chine"],
        ["8485", "Makalu - Himalaya - Népal/Chine"],
        ["8188", "Cho Oyu - Himalaya - Népal/Chine"],
        ["8167", "Dhaulagiri - Népal"],
        ["8163", "Manaslu - Népal"],
        ["8126", "Nanga Parbat - Pakistan"],
        ["8091	", "Annapurna I - Népal"],
      ]);
    },
  },
  {
    link: "https://static.thenounproject.com/png/13643-200.png",
    title: "Deadliest animals in the world",
    nom: "Rank the deadly animals",
    typeOfRank: "(by deaths/year)",
    getTheData: async function (setter) {
      setter([
        ["750000", "Mosquitoes"],
        ["437000", "Humans"],
        ["100000", "Snakes"],
        ["35000", "Dogs"],
        ["20000", "Freshwater snails"],
        ["12000", "Assassin bugs"],
        ["10000", "Tsetse flies"],
        ["4500", "Ascaris roundworms"],
        ["1000", "Crocodiles"],
        ["700	", "Tapeworms"],
      ]);
    },
  },
  {
    link: "https://static.thenounproject.com/png/123929-200.png",
    title: "Most played games",
    nom: "Rank the most played games",
    typeOfRank: "(by player count)",
    getTheData: async function (setter) {
      setter([
        ["1000000000", "CrossFire"],
        ["600000000", "Dungeon Fighter Online"],
        ["600000000", "PlayerUnknown's Battlegrounds"],
        ["505000000", "Pac-Man Doodle"],
        ["500000000", "QQ Speed"],
        ["500000000", "Candy Crush Saga"],
        ["500000000", "Tetris"],
        ["480000000", "Minecraft"],
        ["400000000", "Microsoft solitaire"],
        ["350000000	", "Fortnite"],
      ]);
    },
  },
  {
    link:
      "https://png.pngtree.com/png-clipart/20200226/original/pngtree-set-of-avatar-person-icon-in-flat-design-illustration-png-image_5322558.jpg",
    title: "Most given boys names",
    nom: "Rank the boys names",
    typeOfRank: "(by number of time given last 100y)",
    getTheData: async function (setter) {
      setter([
        ["4764644", "James"],
        ["4546819", "John"],
        ["4535897", "Robert"],
        ["4323074", "Michael"],
        ["3631876", "William"],
        ["3560660", "David"],
        ["2477879", "Richard"],
        ["2367801", "Joseph"],
        ["2167014", "Thomas"],
        ["2124748	", "Charles"],
      ]);
    },
  },
  {
    link:
      "https://img.freepik.com/free-vector/religion-icon-set_1284-5002.jpg?size=338&ext=jpg",
    title: "Largest religious group",
    nom: "Rank the religions",
    typeOfRank: "(by millions followers)",
    getTheData: async function (setter) {
      setter([
        ["2400", "Christianity"],
        ["1800", "Islam"],
        ["1200", "Hinduism"],
        ["520", "Buddhism"],
        ["400", "Folk Religion"],
        ["130", "Taoism"],
        ["100", "Shinto"],
        ["90", "Falun Gung"],
        ["30", "Sikhism"],
        ["14.5", "Judaism"],
      ]);
    },
  },
  {
    link:
      "https://png.pngtree.com/png-clipart/20200226/original/pngtree-set-of-avatar-person-icon-in-flat-design-illustration-png-image_5322558.jpg",
    title: "Most given girls names",
    nom: "Rank the girls names",
    typeOfRank: "(by number of time given last 100y)",
    getTheData: async function (setter) {
      setter([
        ["3328565", "Mary"],
        ["1562727", "Patricia"],
        ["1466854", "Jennifer"],
        ["1448194", "Linda"],
        ["1436232", "Elizabeth"],
        ["1406173", "Barbara"],
        ["1105188", "Susan"],
        ["1044492", "Jessica"],
        ["995436", "Sarah"],
        ["985261	", "Karen"],
      ]);
    },
  },
  {
    link:
      "data:image/png;base64,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",
    title: "The most consumed drinks",
    nom: "Rank the drinks",
    typeOfRank: "(abstract measurement)",
    getTheData: async function (setter) {
      setter([
        ["100", "Tea"],
        ["90", "Coffee"],
        ["80", "Beer"],
        ["70", "Soup"],
        ["60", "Energy drink"],
        ["50", "Vodka"],
        ["40", "Wine"],
        ["30", "Coca Cola"],
        ["20", "Milk"],
        ["10", "Orange juice"],
      ]);
    },
  },
  {
    link:
      "https://icons-for-free.com/iconfiles/png/512/food+icon-1320184414775447246.png",
    title: "The most popular food",
    nom: "Rank the food by popularity",
    typeOfRank: "(abstract measurement)",
    getTheData: async function (setter) {
      setter([
        ["100", "Pizza - Italy"],
        ["90", "Sushi - Japan"],
        ["80", "Ramen - Japan"],
        ["70", "Tacos - Mexico"],
        ["60", "Sashimi - Japan"],
        ["50", "Paella - Spain"],
        ["40", "Mochi - Japan"],
        ["30", "Jiaozi - China"],
        ["20", "Cheeseburger - USA"],
        ["10", "Dim sum - China"],
      ]);
    },
  },
  {
    link:
      "https://i.pinimg.com/originals/50/d2/24/50d224f670f7e7f343fe118c7e18a01b.png",
    title: "The most popular sports",
    nom: "Rank the sports",
    typeOfRank: "(by estimated global following)",
    getTheData: async function (setter) {
      setter([
        ["4000000000", "Soccer"],
        ["2500000000", "Cricket"],
        ["2000000000", "Field Hockey"],
        ["1000000000", "Tennis"],
        ["900000000", "Volleyball"],
        ["875000000", "Table tennis"],
        ["825000000", "Basketball"],
        ["500000000", "Baseball"],
        ["475000000", "Rugby"],
        ["450000000", "Golf"],
      ]);
    },
  },
  {
    link: "https://static.thenounproject.com/png/447465-200.png",
    title: "The most popular websites in the world",
    nom: "Rank the website by popularity",
    typeOfRank: "(by monthly traffic)",
    getTheData: async function (setter) {
      setter([
        ["8564946885", "youtube.com"],
        ["3483131264", "facebook.com"],
        ["2223668855", "en.wikipedia.org"],
        ["2008820315", "twitter.com	"],
        ["618747155", "amazon.com"],
        ["594678708", "play.google.com"],
        ["525400578", "instagram.com"],
        ["450521278", "es.wikipedia.org"],
        ["419840135", "pinterest.com"],
        ["419057040", "live.com"],
      ]);
    },
  },
  {
    link:
      "data:image/png;base64,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",
    title: "The countries with the most inhabitants",
    nom: "Rank the countries",
    typeOfRank: "(by population)",
    getTheData: async function (setter) {
      setter([
        ["1439323776", "China"],
        ["1380004385", "India"],
        ["331002651", "United States"],
        ["273523615", "Indonesia"],
        ["220892340", "Pakistan"],
        ["212559417", "Brazil"],
        ["206139589", "Nigeria"],
        ["164689383", "Bangladesh"],
        ["145934462", "Russia"],
        ["128932753", "Mexico"],
      ]);
    },
  },
  {
    link:
      "https://i.pinimg.com/originals/48/c2/d2/48c2d25d6d660553d7946bee65f6ac39.png",
    title: "Most famous social networks",
    //https://androidrank.org/android-most-popular-google-play-apps?category=SOCIAL&sort=4&price=all
    nom: "Rank these social networks",
    typeOfRank: "(by millions dl)",
    getTheData: async function (setter) {
      setter([
        ["5000", "Facebook"],
        ["1000", "Instagram"],
        ["1000", "TikTok"],
        ["1000", "Snapchat"],
        ["1000", "Facebook Lite"],
        ["1000", "Currents"],
        ["100", "VK"],
        ["100", "Badoo - Dating"],
        ["100", "BIGO LIVE"],
        ["100", "Tango"],
      ]);
    },
  },
  {
    link:
      "https://fr.followersnet.com/wp-content/uploads/2019/01/Spotify-1.png",
    title: "Most listened artists on Spotify",
    nom: "Rank the artists",
    typeOfRank: "(by millions of taps/month (Spotify))",
    getTheData: async function (setter) {

      let res1 = await db.collection("artistSpo").get();

      if (!chargeFb(setter, res1, true)) {
        return;
      }

      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_most-streamed_artists_on_Spotify",
        { mode: "no-cors" }
      );
      
     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;
        for (let child of table) {
          let classs = [];
          let res = true;
          let j = 1;

          for (let miniChild of child.querySelectorAll("td")) {
            if (
              !miniChild.classNames.includes("mbox-image") &&
              !miniChild.classNames.includes("mbox-text")
            ) {
              if (j == 1) {
                miniChild = miniChild.querySelector("a");
              }
              classs[j] = miniChild.innerHTML;
              j--;
              if (j == -1) break;
            } else {
              res = false;
              break;
            }
          }

          if (res && classs.length > 0) {
            childRes.push(classs);
            i++;
            if (i > 9) {
              break;
            }
          }
        }

        for (let i = 1; i < 11; i++) {
          db.collection("artistSpo")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("artistSpo").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }

        setter(childRes);
      }
    },
  },
  {
    link: "https://static.thenounproject.com/png/2385-200.png",
    title: "Highest grossing films",
    nom: "Rank the films",
    typeOfRank: "(by results in theater ($))",
    getTheData: async function (setter) {
      let res1 = await db.collection("filmBO").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }

      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_highest-grossing_films",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            let thune = miniChild[2].innerHTML.replace("$", "");
            let final = "";
            for (let y = 0; y < thune.length; y++) {
              if (thune.charAt(y) !== ",") {
                final += thune.charAt(y);
              }
            }

            classs[0] = final;
            let chillld = child.querySelector("a").innerHTML;
            classs[1] = chillld;
            if (res && classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("filmBO")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("filmBO").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },
  {
    link:
      "data:image/png;base64,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",
    title: "Best selling game consoles",
    nom: "Classifies the consoles",
    typeOfRank: "(by millions sold)",
    getTheData: async function (setter) {
      let res1 = await db.collection("consSe").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_best-selling_game_consoles",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 0) {
                let a = miniChild[j].querySelector("a");
                classs[1] = a.innerHTML;
              } else if (j == 3) {
                let a = miniChild[j].rawText;
                let final = "";
                for (let k = 0; k < a.length; k++) {
                  if (a.charAt(k).match(/^[0-9]$/)) {
                    final += a.charAt(k);
                  } else {
                    if (final != "") {
                      break;
                    }
                  }
                }

                classs[0] = final;

                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("consSe")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("consSe").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },
  {
    link: "https://static.thenounproject.com/png/823776-200.png",
    title: "Most valuable brands",
    nom: "Rank the brand",
    typeOfRank: "(by market capitalization)",
    getTheData: async function (setter) {
      let res1 = await db.collection("brandB").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://brandirectory.com/rankings/global/table",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            let thune = miniChild[4]
              .querySelector("span")
              .innerHTML.replace("$", "");
            thune = thune.replace("M", "");
            let final = "";
            for (let y = 0; y < thune.length; y++) {
              if (thune.charAt(y) !== ",") {
                final += thune.charAt(y);
              }
            }

            classs[0] = final;
            let chillld = miniChild[2].querySelector("a").innerHTML;
            let finall = "";
            for (let y = 0; y < chillld.length; y++) {
              if (chillld.charAt(y).match(/^[a-zA-Z0-9_]*$/)) {
                finall += chillld.charAt(y);
              }
            }
            classs[1] = finall;
            if (res && classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("brandB")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("brandB").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },
  {
    link: "https://static.thenounproject.com/png/823776-200.png",
    title: "Richest people",
    nom: "Rank most rich people",
    typeOfRank: "(by net worth in 2020 (billion $))",
    getTheData: async function (setter) {
      let res1 = await db.collection("richP").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/The_World%27s_Billionaires",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 5) {
            let thune = miniChild[2].rawText;
            let final = "";
            for (let y = 0; y < thune.length; y++) {
              if (thune.charAt(y).match(/^[0-9]$/)) {
                final += thune.charAt(y);
              } else {
                if (final != "") {
                  break;
                }
              }
            }

            classs[0] = final;

            let chillld = miniChild[1].querySelector("a").innerHTML;
            classs[1] = chillld;
            if (res && classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("richP")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("richP").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  //////////////////////////////

  {
    link: "https://static.thenounproject.com/png/123929-200.png",
    title: "Top esports teams",
    nom: "Rank the esports teams",
    typeOfRank: "(by cashprize earned ($))",
    getTheData: async function (setter) {
      let res1 = await db.collection("esportEarn").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }

      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://www.esportsearnings.com/teams",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            let thune = miniChild[2].innerHTML.replace("$", "");
            let final = "";
            for (let y = 0; y < thune.length; y++) {
              if (thune.charAt(y) !== ",") {
                final += thune.charAt(y);
              }
            }

            classs[0] = final;
            let chillld = miniChild[1].querySelector("a").innerHTML;
            classs[1] = chillld;
            if (res && classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("esportEarn")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("esportEarn").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  /////////////////////

  {
    link:
      "data:image/png;base64,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",
    title: "Most famous youtuber",
    nom: "Classifies the youtubers",
    typeOfRank: "(by millions subscribers)",
    getTheData: async function (setter) {
      let res1 = await db.collection("youtSub").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_most-subscribed_YouTube_channels",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 1) {
                let a = miniChild[j].querySelector("a");
                classs[1] = a.innerHTML;
              } else if (j == 2) {
                classs[0] = miniChild[j].innerHTML;
                if (classs[0].includes("sup")) {
                  classs[0] = "59";
                }
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("youtSub")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("youtSub").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  ///////////////////////

  {
    link:
      "https://cdn4.iconfinder.com/data/icons/seo-and-development-22/64/Keyword_search_words_magnifyier_glass-512.png",
    title: "Most used english words",
    nom: "Rank the most used words",
    typeOfRank: "(OEC rank)",
    getTheData: async function (setter) {
      let res1 = await db.collection("wordEN").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/Most_common_words_in_English",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 0) {
                let a = miniChild[j].querySelector("a");
                classs[1] = a.innerHTML;
              } else if (j == 2) {
                classs[0] = (10 - miniChild[j].innerHTML) * 10;
                classs[0] = classs[0] + "";
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        for (let i = 1; i < 11; i++) {
          db.collection("wordEN")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("wordEN").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },
  {
    link:
      "https://yt3.ggpht.com/a/AATXAJyzyrPJMwSCUxtTlY-MQ9sEqX8XHm8MYq4yr7e6Gw=s900-c-k-c0xffffffff-no-rj-mo",
    title: "Most watch netflix shows",
    nom: "Rank the netflix shows",
    typeOfRank: "(by million views)",
    getTheData: async function (setter) {
      setter([
        ["99", "Extraction"],
        ["89", "Bird Box"],
        ["85", "Spenser Confidential"],
        ["83", "Underground "],
        ["83", "Murder Mystery"],
        ["76", "The Witcher"],
        ["65", "Money Heist (season four)"],
        ["64", "Tiger King"],
        ["64", "The Irishman"],
        ["59", "The Wrong Missy"],
      ]);
    },
  },

  {
    link:
      "data:image/png;base64,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",
    title: "Most viewed videos on youtube",
    nom: "Rank the most viewed videos",
    typeOfRank: "(billions views)",
    getTheData: async function (setter) {
      let res1 = await db.collection("youtView").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_most-viewed_YouTube_videos",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 1) {
                let a = miniChild[j].querySelector("a");

                if (a) {
                  classs[1] = a.innerHTML;
                } else {
                  classs[1] = miniChild[j].rawText;
                }

                if (
                  classs[1].indexOf("&") != -1 ||
                  classs[1].indexOf("||") != -1
                ) {
                  classs[1] = "*NameError*";
                }
              } else if (j == 2) {
                let a = miniChild[j].querySelector("a");
                if (a) {
                  classs[1] += " - " + a.innerHTML;
                } else {
                  classs[1] += " - " + miniChild[j].innerHTML;
                }
                classs[1] = classs[1].replace("<i>", "");
                classs[1] = classs[1].replace("</i>", "");
              } else if (j == 3) {
                classs[0] = miniChild[j].innerHTML;
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        //console.log(childRes);
        for (let i = 1; i < 11; i++) {
          db.collection("youtView")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("youtView").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  ///////////////////

  {
    link:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/1200px-Instagram_logo_2016.svg.png",
    title: "Most followed instagram accounts",
    nom: "Rank the instagram accounts",
    typeOfRank: "(by millions followers)",
    getTheData: async function (setter) {
      let res1 = await db.collection("instSub").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_most-followed_Instagram_accounts",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 0) {
                let chh = child.querySelector("a");

                classs[1] = chh.innerHTML;
              } else if (j == 2) {
                classs[0] = miniChild[j].innerHTML;
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        //console.log(childRes);
        for (let i = 1; i < 11; i++) {
          db.collection("instSub")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("instSub").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  {
    link:
      "https://upload.wikimedia.org/wikipedia/fr/thumb/c/c8/Twitter_Bird.svg/1200px-Twitter_Bird.svg.png",
    title: "Most followed twitter accounts",
    nom: "Rank the twitter accounts",
    typeOfRank: "(by millions followers)",
    getTheData: async function (setter) {
      let res1 = await db.collection("twitSub").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_most-followed_Twitter_accounts",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 1) {
                classs[1] = miniChild[j].innerHTML;
                if (classs[1].indexOf("<a") !== -1) {
                  let a = miniChild[j].querySelector("a");
                  classs[1] = a.innerHTML;
                }
              } else if (j == 3) {
                classs[0] = miniChild[j].innerHTML;
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        //console.log(childRes);
        for (let i = 1; i < 11; i++) {
          db.collection("twitSub")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("twitSub").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },

  {
    link:
      "data:image/png;base64,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",
    title: "Most spoken language",
    nom: "Rank most spoken languages",
    typeOfRank: "(by millions speakers)",
    getTheData: async function (setter) {
      let res1 = await db.collection("langWo").get();
      if (!chargeFb(setter, res1, true)) {
        return;
      }
      let res = await fetch(
        "https://thingproxy.freeboard.io/fetch/https://en.wikipedia.org/wiki/List_of_languages_by_number_of_native_speakers",
        { mode: "no-cors" }
      );

     if(res.status != 200) { chargeFb(setter, res1, false) } else {        let res2 = await res.text();
        let table = parse(res2).querySelectorAll("tr");

        let childRes = [];
        let i = 0;

        for (let child of table) {
          let classs = [];
          let miniChild = child.querySelectorAll("td");

          if (miniChild.length > 0) {
            for (let j = 0; j < miniChild.length; j++) {
              if (j == 1) {
                let a = miniChild[j].querySelector("a");
                classs[1] = a.innerHTML;
              } else if (j == 2) {
                classs[0] = miniChild[j].innerHTML;
                break;
              }
            }

            if (classs.length > 0) {
              childRes.push(classs);
              i++;
              if (i > 9) {
                break;
              }
            }
          }
        }
        //console.log(childRes);
        for (let i = 1; i < 11; i++) {
          db.collection("langWo")
            .doc(i + "NB")
            .set({
              rank: i,
              qtt: childRes[i - 1][0],
              name: childRes[i - 1][1],
            });
          db.collection("langWo").doc("updated").set({
            lastUpdate: Date.now(),
          });
        }
        setter(childRes);
      }
    },
  },
];
